import type { Layer } from '../../../models/layer-settings';
import { createWmsGetMapUrl } from './wms-utils';

export const tileJSON = (attrs, minZoom, maxZoom) => ({
  scheme: 'xyz',
  name: 'Fulcrum',
  description: 'Fulcrum',
  version: '2.0.0',
  tilejson: '2.1.0',
  minzoom: minZoom,
  maxzoom: maxZoom,
  ...attrs,
});

const tokenPathSegment = (token?: string | null) => {
  if (!token) {
    return 'jwt';
  }

  return token;
};

export const fulcrumPNGLayer = (layer: Layer, token?: string | null) => `${
  layer.baseURL
}/tile/${tokenPathSegment(token)}/${layer.form}/{z}/{x}/{y}@2x.png?q=${
  encodeURIComponent(layer.filter || '')
}&updated=${layer.lastUpdated}`;

export const fulcrumJSONLayer = (layer: Layer, token?: string | null) => `${
  layer.baseURL
}/tile/${tokenPathSegment(token)}/${layer.form}/{z}/{x}/{y}.json?jsonp=0&q=${
  encodeURIComponent(layer.filter || '')
}&updated=${layer.lastUpdated}`;

export const fulcrumMBTilesPNGLayer = (layer: Layer, token?: string | null) => `${
  layer.baseURL
}/tile/mbtiles/${tokenPathSegment(token)}/${layer.layerID}/{z}/{x}/{y}@2x.png`;

export const fulcrumMBTilesJSONLayer = (layer: Layer, token?: string | null) => `${
  layer.baseURL
}/tile/mbtiles/${tokenPathSegment(token)}/${layer.layerID}/{z}/{x}/{y}.json?jsonp=0`;

export const getTileUrl = (url) => (coord, zoom) => url
  .replace('{x}', coord.x)
  .replace('{y}', coord.y)
  .replace('{z}', zoom);

export const getWmsTileUrl = (url) => (coord, zoom) => {
  try {
    return createWmsGetMapUrl(url, coord.x, coord.y, zoom);
  } catch (error) {
    console.error(error);
    return '';
  }
};
